import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Hero from './components/Hero';
import NotFound from './components/NotFound';
import Tracking from './pages/Tracking';
import Contacts from './pages/Contacts';
import PrivacyAgreement from './pages/PrivacyAgreement';
import "./App.css"

function App() {
  return (
    <div
      data-testid="app-component"
      data-build-revision={process.env.REACT_APP_BUILD_REVISION || 'local'}
      className="flex min-h-screen flex-col"
    >
      <BrowserRouter>
        <Header />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<Hero />} />
            <Route path="/tracking" element={<Tracking />} />
            <Route path="/tracking/:inputData" element={<Tracking />} />
            <Route path="/contacts" element={<Contacts />} />
            <Route path='*' element={<NotFound />}/>
            <Route path="/privacyAgreement" element={<PrivacyAgreement />} />
          </Routes>
        </main>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
